import * as React from 'react';
export const UiKitContext = /*#__PURE__*/React.createContext({
  deviceType: 'desktop',
  useStaticDeviceType: false
});
export function useUiKitContext() {
  return React.useContext(UiKitContext);
}